export const emptyArray = (size: number): null[] => new Array(size).fill(null);

export const immutableSplice = <T>(
  array: T[],
  start: number,
  deleteCount: number,
  ...items: T[]
): T[] => {
  const copy = [...array];
  copy.splice(start, deleteCount, ...items);
  return copy;
};

export const filterUnique = <T>(
  item: T,
  index: number,
  self: T[]
): boolean => index === self.indexOf(item);
